export const originalWorks = [
  {
    img: "/images/original-boxes1.webp",
    extra: ["/images/boxes1-b.webp", "/images/boxes1-c.webp"],
    className: "md:col-span-5",
    ratio: "aspect-[2/3]",
    fr: { title: "Don't fit into boxes #1", medium: "Acrylique sur toile — 40 × 50 cm" },
    en: { title: "Don't fit into boxes #1", medium: "Acrylic on canvas — 40 × 50 cm" },
    year: "",
    price: "600 AUD",
  },
  {
    img: "/images/original-boxes2.webp",
    extra: ["/images/boxes2-close.webp"],
    className: "md:col-span-6 md:col-start-7",
    ratio: "aspect-[2/3]",
    fr: { title: "Don't fit into boxes #2", medium: "Acrylique sur toile — 40 × 50 cm" },
    en: { title: "Don't fit into boxes #2", medium: "Acrylic on canvas — 40 × 50 cm" },
    year: "",
    price: "600 AUD",
  },
  {
    img: "/images/original-boxes3.webp",
    extra: ["/images/boxes3-trio.webp", "/images/boxes3-close.webp"],
    className: "md:col-span-4 md:col-start-2",
    ratio: "aspect-[2/3]",
    fr: { title: "Don't fit into boxes #3", medium: "Acrylique sur toile — 40 × 50 cm" },
    en: { title: "Don't fit into boxes #3", medium: "Acrylic on canvas — 40 × 50 cm" },
    year: "",
    price: "600 AUD",
  },
  {
    img: "/images/boxes4-main.webp",
    extra: ["/images/boxes4-frame.webp"],
    className: "md:col-span-4",
    ratio: "aspect-[4/5]",
    fr: { title: "Don't fit into boxes #4", medium: "Acrylique sur toile — 23 × 30 cm" },
    en: { title: "Don't fit into boxes #4", medium: "Acrylic on canvas — 23 × 30 cm" },
    year: "",
    sold: true,
  },
  {
    img: "/images/original-boxes5.webp",
    extra: ["/images/boxes5-b.webp", "/images/boxes5-c.webp"],
    className: "md:col-span-5 md:col-start-8",
    ratio: "aspect-[3/4]",
    fr: { title: "Don't fit into boxes #5", medium: "Acrylique sur toile — 48 × 150 cm" },
    en: { title: "Don't fit into boxes #5", medium: "Acrylic on canvas — 48 × 150 cm" },
    year: "",
    price: "600 AUD",
  },
  {
    img: "/images/boxes6-main.webp",
    extra: ["/images/boxes6-frame.webp", "/images/boxes6-detail.webp", "/images/boxes6-signature.webp"],
    className: "md:col-span-5",
    ratio: "aspect-[4/5]",
    fr: { title: "Don't fit into boxes #6", medium: "Tissu naturel coton & lin — 73 × 95 cm — Non encadré" },
    en: { title: "Don't fit into boxes #6", medium: "Natural cotton & linen fabric — 73 × 95 cm — Unframed" },
    year: "",
    price: "700 AUD",
  },
  {
    img: "/images/boxes7-main.webp",
    extra: ["/images/boxes7-frame.webp", "/images/boxes7-flat.webp", "/images/boxes7-signature.webp", "/images/boxes7-edge.webp"],
    className: "md:col-span-5",
    ratio: "aspect-[4/5]",
    fr: { title: "Don't fit into boxes #7", medium: "Tissu naturel coton & lin — 63 × 95 cm — Non encadré" },
    en: { title: "Don't fit into boxes #7", medium: "Natural cotton & linen fabric — 63 × 95 cm — Unframed" },
    year: "",
    price: "700 AUD",
  },
  {
    img: "/images/chignon13-main.webp",
    extra: ["/images/chignon13-frame.webp", "/images/chignon13-flat.webp"],
    className: "md:col-span-5",
    ratio: "aspect-[4/5]",
    fr: { title: "Chignon #13", medium: "Acrylique sur papier 180g — 29,7 × 49 cm — Non encadré" },
    en: { title: "Chignon #13", medium: "Acrylic on 180g paper — 29.7 × 49 cm — Unframed" },
    year: "",
    price: "300 AUD",
  },
  {
    img: "/images/chignon14-main.webp",
    extra: ["/images/chignon14-flat.webp"],
    className: "md:col-span-5 md:col-start-8",
    ratio: "aspect-[4/5]",
    fr: { title: "Chignon #14", medium: "Acrylique sur papier 180g — 29,7 × 49 cm — Non encadré" },
    en: { title: "Chignon #14", medium: "Acrylic on 180g paper — 29.7 × 49 cm — Unframed" },
    year: "",
    price: "300 AUD",
  },
  {
    img: "/images/chignon15-main.webp",
    extra: ["/images/chignon15-frame.webp", "/images/chignon15-flat.webp"],
    className: "md:col-span-6 md:col-start-1",
    ratio: "aspect-[4/3]",
    fr: { title: "Chignon #15", medium: "Acrylique sur papier 180g — 29,7 × 49 cm — Non encadré" },
    en: { title: "Chignon #15", medium: "Acrylic on 180g paper — 29.7 × 49 cm — Unframed" },
    year: "",
    price: "300 AUD",
  },
  {
    img: "/images/chignon16-main.webp",
    extra: ["/images/chignon16-flat.webp"],
    className: "md:col-span-4 md:col-start-9",
    ratio: "aspect-[3/4]",
    fr: { title: "Chignon #16", medium: "Acrylique sur papier — 49 × 52 cm — Non encadré" },
    en: { title: "Chignon #16", medium: "Acrylic on paper — 49 × 52 cm — Unframed" },
    year: "",
    price: "600 AUD",
  },
  {
    img: "/images/chignon17-main.webp",
    extra: ["/images/chignon17-frame.webp", "/images/chignon17-flat.webp"],
    className: "md:col-span-5",
    ratio: "aspect-[4/5]",
    fr: { title: "Chignon #17", medium: "Acrylique sur papier 180g — 49 × 52 cm — Non encadré" },
    en: { title: "Chignon #17", medium: "Acrylic on 180g paper — 49 × 52 cm — Unframed" },
    year: "",
    price: "600 AUD",
  },
  {
    img: "/images/chignon18-main.webp",
    extra: ["/images/chignon18-flat.webp"],
    className: "md:col-span-5 md:col-start-8",
    ratio: "aspect-[4/5]",
    fr: { title: "Chignon #18", medium: "Acrylique sur papier 180g — 49 × 52 cm — Non encadré" },
    en: { title: "Chignon #18", medium: "Acrylic on 180g paper — 49 × 52 cm — Unframed" },
    year: "",
    price: "600 AUD",
  },
  {
    img: "/images/chignon19-flat.webp",
    extra: ["/images/chignon19-main.webp"],
    className: "md:col-span-6 md:col-start-2",
    ratio: "aspect-square",
    fr: { title: "Chignon #19", medium: "Acrylique sur papier 180g — 49 × 52 cm — Non encadré" },
    en: { title: "Chignon #19", medium: "Acrylic on 180g paper — 49 × 52 cm — Unframed" },
    year: "",
    price: "600 AUD",
  },
  {
    img: "/images/sold-1.webp",
    className: "md:col-span-6 md:col-start-1",
    ratio: "aspect-[5/4]",
    fr: { title: "Chignon #1", medium: "Acrylique sur papier 180g — 49 × 52 cm" },
    en: { title: "Chignon #1", medium: "Acrylic on 180g paper — 49 × 52 cm" },
    year: "",
    sold: true,
  },
  {
    img: "/images/sold-2.webp",
    className: "md:col-span-4 md:col-start-8",
    ratio: "aspect-[3/4]",
    fr: { title: "Chignon #2", medium: "Acrylique sur papier 180g — 49 × 52 cm" },
    en: { title: "Chignon #2", medium: "Acrylic on 180g paper — 49 × 52 cm" },
    year: "",
    sold: true,
  },
  {
    img: "/images/sold-3.webp",
    className: "md:col-span-6 md:col-start-2",
    ratio: "aspect-[4/3]",
    fr: { title: "Chignon #3", medium: "Acrylique sur papier 180g — 49 × 52 cm" },
    en: { title: "Chignon #3", medium: "Acrylic on 180g paper — 49 × 52 cm" },
    year: "",
    sold: true,
  },
  {
    img: "/images/sold-4.webp",
    className: "md:col-span-5 md:col-start-8",
    ratio: "aspect-[4/3]",
    fr: { title: "Chignon #4", medium: "Acrylique sur papier 180g — 49 × 52 cm" },
    en: { title: "Chignon #4", medium: "Acrylic on 180g paper — 49 × 52 cm" },
    year: "",
    sold: true,
  },
  {
    img: "/images/sold-5.webp",
    className: "md:col-span-6 md:col-start-3",
    ratio: "aspect-[4/3]",
    fr: { title: "Chignon #5", medium: "Acrylique sur papier 180g — 49 × 52 cm" },
    en: { title: "Chignon #5", medium: "Acrylic on 180g paper — 49 × 52 cm" },
    year: "",
    sold: true,
  },
  {
    img: "/images/sold-6.webp",
    className: "md:col-span-5 md:col-start-1",
    ratio: "aspect-square",
    fr: { title: "Chignon #6", medium: "Acrylique sur papier 180g — 49 × 52 cm" },
    en: { title: "Chignon #6", medium: "Acrylic on 180g paper — 49 × 52 cm" },
    year: "",
    sold: true,
  },
  {
    img: "/images/sold-7.webp",
    className: "md:col-span-4 md:col-start-7",
    ratio: "aspect-[4/5]",
    fr: { title: "Chignon #7", medium: "Acrylique sur toile — 100 × 100 cm" },
    en: { title: "Chignon #7", medium: "Acrylic on canvas — 100 × 100 cm" },
    year: "",
    sold: true,
  },
  {
    img: "/images/sold-8.webp",
    className: "md:col-span-6 md:col-start-2",
    ratio: "aspect-square",
    fr: { title: "Chignon #8", medium: "Acrylique sur toile — 140 × 90 cm" },
    en: { title: "Chignon #8", medium: "Acrylic on canvas — 140 × 90 cm" },
    year: "",
    sold: true,
  },
  {
    img: "/images/sold-9.webp",
    className: "md:col-span-5 md:col-start-9",
    ratio: "aspect-[4/5]",
    fr: { title: "Chignon #9", medium: "Acrylique sur papier 180g — 49 × 52 cm" },
    en: { title: "Chignon #9", medium: "Acrylic on 180g paper — 49 × 52 cm" },
    year: "",
    sold: true,
  },
  {
    img: "/images/sold-10.webp",
    className: "md:col-span-4 md:col-start-4",
    ratio: "aspect-[4/5]",
    fr: { title: "Chignon #10", medium: "Acrylique sur papier 180g — 49 × 52 cm" },
    en: { title: "Chignon #10", medium: "Acrylic on 180g paper — 49 × 52 cm" },
    year: "",
    sold: true,
  },
  {
    img: "/images/chignon-11.webp",
    className: "md:col-span-6 md:col-start-2",
    ratio: "aspect-[6/5]",
    fr: { title: "Chignon #11", medium: "Acrylique sur papier brun — A4" },
    en: { title: "Chignon #11", medium: "Acrylic on brown paper — A4" },
    year: "",
    sold: true,
  },
  {
    img: "/images/chignon-12.webp",
    className: "md:col-span-5 md:col-start-9",
    ratio: "aspect-[6/5]",
    fr: { title: "Chignon #12", medium: "Acrylique sur papier brun — A4" },
    en: { title: "Chignon #12", medium: "Acrylic on brown paper — A4" },
    year: "",
    sold: true,
  },
];

export const tapestries = [
  {
    img: "/images/day1-main.webp",
    className: "md:col-span-4 md:col-start-2",
    ratio: "aspect-[4/5]",
    fr: { title: "DAY 1", medium: "Lin & coton — œillets métal" },
    en: { title: "DAY 1", medium: "Linen & cotton — metal eyelets" },
    year: "",
  },
  {
    img: "/images/tapestry-day2.webp",
    extra: ["/images/day2-room.webp", "/images/day2-flat.webp", "/images/day2-eyelet.webp", "/images/day2-back.webp"],
    className: "md:col-span-5 md:col-start-7",
    ratio: "aspect-[3/4]",
    fr: { title: "DAY 2", medium: "Lin & coton — œillets métal" },
    en: { title: "DAY 2", medium: "Linen & cotton — metal eyelets" },
    year: "",
  },
  {
    img: "/images/tapestry-day3.webp",
    className: "md:col-span-5 md:col-start-1",
    ratio: "aspect-square",
    fr: { title: "DAY 3", medium: "Lin & coton — œillets métal" },
    en: { title: "DAY 3", medium: "Linen & cotton — metal eyelets" },
    year: "",
  },
  {
    img: "/images/day4-room.webp",
    className: "md:col-span-5 md:col-start-7",
    ratio: "aspect-[4/5]",
    fr: { title: "DAY 4", medium: "Lin & coton — œillets métal" },
    en: { title: "DAY 4", medium: "Linen & cotton — metal eyelets" },
    year: "",
  },
  {
    img: "/images/day5-room.webp",
    className: "md:col-span-4 md:col-start-2",
    ratio: "aspect-[4/5]",
    fr: { title: "DAY 5", medium: "Lin & coton — œillets métal" },
    en: { title: "DAY 5", medium: "Linen & cotton — metal eyelets" },
    year: "",
  },
  {
    img: "/images/day6-room.webp",
    className: "md:col-span-5 md:col-start-7",
    ratio: "aspect-[4/5]",
    fr: { title: "DAY 6", medium: "Lin & coton — œillets métal" },
    en: { title: "DAY 6", medium: "Linen & cotton — metal eyelets" },
    year: "",
  },
  {
    img: "/images/day7.webp",
    extra: ["/images/day7-close.webp"],
    className: "md:col-span-4 md:col-start-1",
    ratio: "aspect-[3/4]",
    fr: { title: "DAY 7", medium: "Lin & coton — œillets métal" },
    en: { title: "DAY 7", medium: "Linen & cotton — metal eyelets" },
    year: "",
  },
  {
    img: "/images/day8.webp",
    extra: ["/images/day8-room.webp"],
    className: "md:col-span-6 md:col-start-6",
    ratio: "aspect-[6/5]",
    fr: { title: "DAY 8", medium: "Lin & coton — œillets métal" },
    en: { title: "DAY 8", medium: "Linen & cotton — metal eyelets" },
    year: "",
  },
  {
    img: "/images/day9-room.webp",
    className: "md:col-span-5 md:col-start-2",
    ratio: "aspect-[4/5]",
    fr: { title: "DAY 9", medium: "Lin & coton — œillets métal" },
    en: { title: "DAY 9", medium: "Linen & cotton — metal eyelets" },
    year: "",
  },
  {
    img: "/images/tapestry-day10-terracotta.webp",
    className: "md:col-span-5 md:col-start-8",
    ratio: "aspect-[3/4]",
    fr: { title: "DAY 10", medium: "Lin & coton — œillets métal" },
    en: { title: "DAY 10", medium: "Linen & cotton — metal eyelets" },
    year: "",
  },
  {
    img: "/images/day11-room.webp",
    className: "md:col-span-5 md:col-start-1",
    ratio: "aspect-[4/5]",
    fr: { title: "DAY 11", medium: "Lin & coton — œillets métal" },
    en: { title: "DAY 11", medium: "Linen & cotton — metal eyelets" },
    year: "",
  },
  {
    img: "/images/day12-room.webp",
    className: "md:col-span-4 md:col-start-7",
    ratio: "aspect-[4/5]",
    fr: { title: "DAY 12", medium: "Lin & coton — œillets métal" },
    en: { title: "DAY 12", medium: "Linen & cotton — metal eyelets" },
    year: "",
  },
  {
    img: "/images/day13-room.webp",
    className: "md:col-span-5 md:col-start-2",
    ratio: "aspect-[4/5]",
    fr: { title: "DAY 13", medium: "Lin & coton — œillets métal" },
    en: { title: "DAY 13", medium: "Linen & cotton — metal eyelets" },
    year: "",
  },
];

export const heroImage = "/images/tapestry-day2.webp";

export const portraitImage = "/images/portrait.webp";

export const expoImages = [
  { img: "/images/expo-1.webp", className: "md:col-span-5", ratio: "aspect-[4/3]" },
  { img: "/images/expo-2.webp", className: "md:col-span-4", ratio: "aspect-[4/3]" },
  { img: "/images/expo-3.webp", className: "md:col-span-3", ratio: "aspect-[3/4]" },
  { img: "/images/expo-4.webp", className: "md:col-span-7", ratio: "aspect-[16/10]" },
  { img: "/images/expo-5.webp", className: "md:col-span-5", ratio: "aspect-[4/3]" },
];

export const tapestryShared = [
  "/images/detail-eyelet.webp",
  "/images/detail-line.webp",
  "/images/detail-edge.webp",
  "/images/detail-eyelet2.webp",
  "/images/detail-fold.webp",
];
